import { Deserializable } from '../../protocols/deserializable';
import { UniquelyIdentifiable } from '../../protocols/uniquely-identifiable';
import { Asset } from '../../image/dto/asset';
import { HighGuideTrendDirection } from '../../enum/dto/high-guide-trend-direction.enum';

/**
 * One brand's standing in the What's Hot strip, precomputed server side for the insights reporting window.
 *
 * `rank` is the position to draw and `trendDirection` the chevron to draw beside it - the client never reproduces
 * the ranking math. The remaining scores are informational, carried so the shape stays traceable to the backend
 * struct even though nothing renders them today.
 */
export class HighGuideTrendingBrand implements Deserializable, UniquelyIdentifiable {
  public rank: number;
  public brand: string;
  public brandNameId: string;
  public logo: Asset;
  public trendDirection: HighGuideTrendDirection;
  public trendScore: number;
  public productSignalScore: number;
  public signalCount: number;
  public contributorCount: number;
  public signalledVariantCount: number;

  onDeserialize(): void {
    this.logo = window?.injector?.Deserialize?.instanceOf(Asset, this.logo);
  }

  /**
   * The value the trend chevron is picked from. A direction the catalogue has not been taught yet reads as flat, so
   * a new backend value adds a brand card with no arrow instead of a card with a missing icon.
   */
  getTrendDirection(): HighGuideTrendDirection {
    const known = Object.values(HighGuideTrendDirection).includes(this.trendDirection);
    return known ? this.trendDirection : HighGuideTrendDirection.Flat;
  }

  getUniqueIdentifier(): string {
    return `${this.brandNameId}-${this.rank}-${this.trendDirection}-${this.logo?.getUniqueIdentifier()}`;
  }
}
